import { createSlice } from '@reduxjs/toolkit';
import { timeworkSheetState } from './timeworkSheetTypes'; // Types for the state
import { createWorkLog, fetchWorkLogById, fetchAllWorkLogs, updateWorkLog, deleteWorkLog, fetchWorkLogsByEmployeeId } from './timeworkSheetAction';
import { fetchWorklogsBySupervisorHierarchy } from '../../reports/timesheet_report/timesheet.Action';

const initialState: timeworkSheetState = {
  workLogs: [],
  workLogsBySupervisor: [],
  worklogsByEmployeeId: [],
  selectedWorkLog: undefined,
  loading: false,
  error: undefined,
};

const timeworkSheetSlice = createSlice({
  name: 'timeworkSheet',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Work Log
      .addCase(createWorkLog.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createWorkLog.fulfilled, (state, action) => {
        state.loading = false;
        state.workLogs.push(action.payload);
      })
      .addCase(createWorkLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      
      // Get Work Log by ID
      .addCase(fetchWorkLogById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchWorkLogById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedWorkLog = action.payload;
      })
      .addCase(fetchWorkLogById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      
      // Get All Work Logs
      .addCase(fetchAllWorkLogs.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAllWorkLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.workLogs = action.payload.data;
      })
      .addCase(fetchAllWorkLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      
      // Update Work Log
      .addCase(updateWorkLog.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateWorkLog.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.workLogs.findIndex(workLog => workLog.work_id === action.payload.work_id);
        if (index !== -1) {
          state.workLogs[index] = action.payload;
        }
      })
      .addCase(updateWorkLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Work Log
      .addCase(deleteWorkLog.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteWorkLog.fulfilled, (state, action) => {
        state.loading = false;
        state.workLogs = state.workLogs.filter(workLog => workLog.work_id !== action.payload.workId);
      })
      .addCase(deleteWorkLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Work Logs by Supervisor Hierarchy
      .addCase(fetchWorklogsBySupervisorHierarchy.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchWorklogsBySupervisorHierarchy.fulfilled, (state, action) => {
        state.loading = false;
        state.workLogsBySupervisor = action.payload.data;
      })
      .addCase(fetchWorklogsBySupervisorHierarchy.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      //fetch workLog by employeeId
      .addCase(fetchWorkLogsByEmployeeId.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchWorkLogsByEmployeeId.fulfilled, (state, action) => {
        state.loading = false;
        state.worklogsByEmployeeId = action.payload.data;
      })
      .addCase(fetchWorkLogsByEmployeeId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});

export default timeworkSheetSlice.reducer;
